class Customer.ResponseTemplateItemView extends Backbone.View
  template: JST["backbone/templates/customer/ticket/response_template/response_template_item"]

  events:
    'click .delete': 'onDelete'
    'click .btn_user': '_addUser'
    'click .btn_date': '_addDate'
    'click .btn_ticket_id': '_addTicketId'
    'click .btn_username': '_addUsername'
    'focus .response-template-text': '_onFocus'

  initialize: ({responseItemCounter}) ->
    @responseItemCounter = responseItemCounter

  render: ({text, mode}) =>
    @$el.html(@template({responseItemCounter: @responseItemCounter}))
    @textEditor = new ToggleableHTMLEditorView(mode: mode, textLimit: 255, boxSize: 2, codeEditorEnabled: true)
    @$el.find('.response-template-text').html(@textEditor.render(text).el)
    @

  onDelete: ->
    @trigger('destroy', @)

  getText: =>
    @textEditor.getPlainHTML() || @textEditor.getPlainText()

  isEmpty: =>
    _.string.isBlank(@textEditor.getPlainText())

  focus: =>
    @textEditor.focus()

  toggleError: (showError) =>
    @textEditor.toggleError(showError)

  toggleMode: (mode) =>
    @textEditor.toggleMode(mode)

  _onFocus: =>
    @trigger('focus')

  _addUser: =>
    @textEditor.insertTextAtCursor('{{user}}')

  _addDate: =>
    @textEditor.insertTextAtCursor('{{date}}')

  _addTicketId: =>
    @textEditor.insertTextAtCursor('{{ticket_id}}')

  _addUsername: =>
    @textEditor.insertTextAtCursor('{{@user}}')
